import { FeatureProps } from './types'

export const getDefaultFeatures = (): FeatureProps[] => {
	return [
		{
			icon: 'BarCustom',
			text: 'Sleep stages',
		},
		{
			icon: 'CalendarLight',
			text: 'Age',
		},
		{
			icon: 'GenderLight',
			text: 'Biological sex',
		},
		{
			icon: 'ClockLight',
			text: 'Bedtime',
		},
		{
			icon: 'WeatherCustom',
			text: 'Local weather',
		},
		{
			icon: 'TemperatureLight',
			text: 'Temperature preferences',
		},
		{
			icon: 'HomeLight',
			text: 'Bedroom temperature',
		},
		{
			icon: 'AlarmLight',
			text: 'Wakeup time',
		},
	]
}
